'use client';

import { BlogArticlePage } from '@/components/pages/blog/BlogArticlePage';
import { useAppNavigate } from '../../_lib/useAppNavigate';
import type { BlogPostDocument } from '@/firebase/blog-db';

export default function BlogArticleClient({ post }: { post: BlogPostDocument }) {
  const navigate = useAppNavigate();
  return <BlogArticlePage post={post} onNavigate={navigate} />;
}
